import { EventType, SourcePages, Features } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';
import { VehicleEventInfo } from '../../types';

const event = ({ trackingParams }: VehicleEventInfo): EventData => {
  return {
    event_type: EventType.engagement,
    source_page: SourcePages.Vdp,
    feature: Features.warranty,
    engagement_type: 'warranty_tap',
    event_context: {
      tracking_params: trackingParams,
    },
  };
};

export default event;
